import React, { useEffect } from "react";
import "./liverate.css";
import { NavLink, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";

const Liverate = () => {

  const metals = [
    { id: "gold", metal: "Gold" },
    { id: "silver", metal: "Silver" },
    // { id: "platinum", metal: "Platinum" },
  ];

  const [searchParams] = useSearchParams();
  const selectedState = searchParams.get("state") || "Gujarat";

  return (
    <>
      <Helmet>
        <title>Live Gold Rate Today in India | 24K, 22K & 18K Price – Gold-Rate-Today.com</title>

        <meta
          name="description"
          content="Check today's live gold rate in India for 24K, 22K & 18K gold. View the latest gold price chart, historical data, and updates with live trading charts."
        />
        <meta
          name="keywords"
          content="live gold rate, today gold price, 24k gold rate, 22k gold rate, 18k gold rate, gold price chart, historical gold rate, Gujarat gold rate, gold price India"
        />

        {/* Open Graph for social sharing */}
        <meta property="og:title" content="Live Gold Rate Today – 24K, 22K & 18K Gold Price Chart" />
        <meta
          property="og:description"
          content="Get today's gold rate for 24K, 22K & 18K gold in India. View live charts, historical prices, and gold news on Gold-Rate-Today.com."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://gold-rate-today.com/liverate" />
        <meta property="og:image" content="https://gold-rate-today.com/images/gold-chart-preview.jpg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Live Gold Rate in India – Gold-Rate-Today.com" />
        <meta
          name="twitter:description"
          content="Track real-time gold rates for 24K, 22K, and 18K gold in India. Compare live prices and view charts."
        />
        <meta name="twitter:image" content="https://gold-rate-today.com/images/gold-chart-preview.jpg" />

        {/* Canonical link */}
        <link rel="canonical" href="https://gold-rate-today.com/liverate" />

        {/* Structured data (JSON-LD) for better SEO indexing */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Live Gold Rate Today in India",
            "url": "https://gold-rate-today.com/liverate",
            "description": "Check the latest live gold rate for 24K, 22K & 18K gold in India. View live charts, historical prices, and updates.",
            "publisher": {
              "@type": "Organization",
              "name": "Gold-Rate-Today.com",
              "url": "https://gold-rate-today.com/"
            }
          }
        `}</script>
      </Helmet>

      <section className="liverate-section">
        <div className="container">
          <div className="row">
            <div className="metal-types-tab">
              <ul>
                {metals.map(({ id, metal }) => (
                  <li key={id}>
                    <NavLink
                      to={`/${metal.toLowerCase()}?state=${selectedState}`}
                    >
                      {metal}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Liverate;
